export default __webpack_public_path__ + "static/media/Juneau-Regular.2dd0b891.ttf";